import type { ColumnDef } from "@tanstack/react-table";

import type { IPortfoliosTable } from "./types";

import { translate } from "utils/translations/translate";

const getColumns = (canGetGroups: boolean): ColumnDef<IPortfoliosTable>[] => [
  {
    accessorKey: "portfolio",
    header: translate.t("organization.tabs.portfolios.table.portfolio"),
    minSize: 300,
  },
  ...(canGetGroups
    ? [
        {
          accessorKey: "nGroups",
          header: translate.t("organization.tabs.portfolios.table.nGroups"),
          minSize: 100,
        },
        {
          accessorKey: "groups",
          header: translate.t("organization.tabs.portfolios.table.groups"),
          minSize: 707,
        },
      ]
    : []),
];

export { getColumns };
